import React from 'react';
import { useIntl } from 'react-intl';
import core from '@gin-betting/core';
import { map } from 'lodash';

import { GameLogo, Icon, SportFilterHeading } from 'components';
import { usePureSelector } from 'hooks';
import globalMessages from 'messages';
import { ALL } from '../../../constants';

import allGames from 'assets/svg/all-games.svg';
import './sportsList.scss';

const {
    entities: {
        selectors: { selectSports },
    },
} = core;

interface Props {
    activeSport: string;
    sportIds: string[];
    makeHandleChangeActiveSport: (sportId: string) => VoidFunction;
}

const SportsList: React.FC<Props> = ({
    activeSport,
    sportIds,
    makeHandleChangeActiveSport,
}) => {
    const { formatMessage } = useIntl();

    const allSports = usePureSelector(selectSports);
    const allGamesMsg = formatMessage(globalMessages.allGames);

    return (
        <div styleName="container">
            <SportFilterHeading
                key={ALL}
                onClick={makeHandleChangeActiveSport(ALL)}
                isActive={activeSport === ALL}
                logo={<Icon glyph={allGames} />}
                title={allGamesMsg}
            />

            {map(sportIds, sportId => {
                if (sportId === ALL) return null;

                const sportName = allSports.get(sportId)?.name ?? '';

                return (
                    <SportFilterHeading
                        key={sportId}
                        isActive={activeSport === sportId}
                        logo={<GameLogo gameId={sportId} />}
                        title={sportName}
                        onClick={makeHandleChangeActiveSport(sportId)}
                    />
                );
            })}
        </div>
    );
};

export default React.memo(SportsList);
